export enum AnalyzeType {
  Total = 'total',
  Annually = 'annually',
  Monthly = 'monthly',
  Month = 'month',
  Velodrome = 'velodrome',
  TimeFrame = 'time_frame',
  GradeName = 'grade_name',
}
